import * as api from '../api/index'
import { ADD_NEW_CONTACT, UPDATE_CONTACT, DELETE_CONTACT, FETCH_CONTACTS_BY_USER, START_LOADING, END_LOADING } from './constants'

export const getContactsByUser = (searchQuery) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING })
    const { data: { data } } = await api.fetchContactsByUser(searchQuery)
    dispatch({ type: FETCH_CONTACTS_BY_USER, payload: data })
    dispatch({ type: END_LOADING })
  } catch (error) {
    console.log(error.response || error)
  }
}

export const createContact = (contact, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.addContact(contact)
    dispatch({ type: ADD_NEW_CONTACT, payload: data })
    openSnackbar && openSnackbar('Contact added successfully')
  } catch (error) {
    console.log(error)
  }
}

export const updateContact = (id, contact, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateContact(id, contact)
    dispatch({ type: UPDATE_CONTACT, payload: data })
    openSnackbar && openSnackbar('Contact updated successfully')
  } catch (error) {
    console.log(error)
  }
}

export const deleteContact = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteContact(id)
    dispatch({ type: DELETE_CONTACT, payload: id })
    openSnackbar && openSnackbar('Contact deleted successfully')
  } catch (error) {
    console.log(error)
  }
}
